//import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "./Categories.css";
import Footer from "../components/Footer";
import Basic from "../components/Basic";
import "jquery/dist/jquery.slim";
import "bootstrap/dist/js/bootstrap.bundle";
//import PlantModal from "../components/PlantModal";
import UserModal from "../components/UserModal";
import Dialog from "../components/Dialog";
//import { Link } from "react-router-dom";
//import { FaSearch } from "react-icons/fa";
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Pagination } from "react-bootstrap";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
//import { FaSearch } from "react-icons/fa";

import Tooltip from "@mui/material/Tooltip";

//import Search from "../components/Search";

function Shrubs() {
  const [currentPage, setCurrentPage] = useState(1);
  const [plantsPerPage] = useState(24);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const [Plants, setPlants] = useState([]);

  const fetchPlants = useCallback(() => {
    axios
      .get(
        `https://server-zqk9.onrender.com/Shrubs?search=${searchTerm}`
      )
      .then((response) => {
        setPlants(response.data);
      })
      .catch((err) => console.log(err));
  }, [searchTerm]);

  // Debounce function
  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const debouncedFetchPlants = useCallback(
    debounce(fetchPlants, 500), // Adjust the delay time as needed
    [fetchPlants]
  );

  useEffect(() => {
    debouncedFetchPlants();

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const scrollThreshold = -1;

      if (scrollPosition > scrollThreshold) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [debouncedFetchPlants, location]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    debouncedFetchPlants();
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastPlant = currentPage * plantsPerPage;
  const indexOfFirstPlant = indexOfLastPlant - plantsPerPage;
  const currentPlants = Plants.slice(indexOfFirstPlant, indexOfLastPlant);
  return (
    <>
      <Basic />

      <div className="containersec1">
        <div className="header1">
          <h1>
            <span style={{ color: "#179f3e" }}>SHRUBS</span>
          </h1>
          <p>
            Enhance your landscape with versatile shrubs; explore our collection
            of shrubs offering year-round beauty and low maintenance. Shrubs are
            woody plants that are smaller than trees and have multiple stems or
            branches arising from the base. They are typically larger than herbs
            but smaller than trees. Shrubs can be deciduous (losing their leaves
            in winter) or evergreen (retain their leaves throughout the year).
          </p>
          <img className="images" class="center" src="Shrubs1.jpg" alt="" />
        </div>
      </div>
      <div className="Shrubs">
        <div className="Sections">
          <div className="col-md-6 main">
            <h1>
              <u>Shrubs List</u>
            </h1>
          </div>
          <div className="plant">
            <p>
              Below, you'll find a catalog of plants accompanied by insightful
              information.
            </p>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <div className="search-bar-container1">
              <input
                type="text"
                className="form-control search-bar-input1"
                placeholder="Search for plants"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button
                type="button"
                onClick={handleSearch}
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  marginRight: "50px",
                }}
              >
                {/* <FaSearch /> */}
              </button>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              {currentPlants.length > 0 ? (
                currentPlants.map((plant, index) => (
                  <div className="col-md-4" key={index}>
                    <div className="container1 py-2">
                      <div className="rectangle1">
                        <div className="circle">
                          <img src={`${plant?.image?.images}`} alt="" />
                        </div>
                        <div className="content1">
                          <Dialog {...plant} />
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-md-12">
                  <h2
                    style={{
                      color: "white",
                      fontSize: "20px",
                      textAlign: "center",
                    }}
                  >
                    No such Shrub found in our record!!
                  </h2>
                </div>
              )}
            </div>
            <div className="pagination-container d-flex justify-content-center mt-3">
              <Pagination style={{ fontSize: "1.2rem" }}>
                <Pagination.Prev
                  disabled={currentPage === 1}
                  onClick={() => paginate(currentPage - 1)}
                >
                  <FaAngleLeft />
                </Pagination.Prev>

                {Array.from({
                  length: Math.ceil(Plants.length / plantsPerPage),
                }).map((_, index) => {
                  // Display only three items at a time
                  if (
                    (currentPage <= 2 && index < 3) ||
                    (currentPage > 2 &&
                      index >= currentPage - 2 &&
                      index <= currentPage)
                  ) {
                    return (
                      <Pagination.Item
                        key={index}
                        active={index + 1 === currentPage}
                        onClick={() => paginate(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    );
                  }
                  return null;
                })}

                <Pagination.Next
                  disabled={
                    currentPage === Math.ceil(Plants.length / plantsPerPage)
                  }
                  onClick={() => paginate(currentPage + 1)}
                >
                  <FaAngleRight />
                </Pagination.Next>
              </Pagination>
            </div>
          </div>

          <Tooltip title="Add plants">
            <button className="Addbtn ">
              <UserModal />
            </button>
          </Tooltip>
          {showScrollButton && (
            <Tooltip title="Scroll up">
              <button className="back-to-top" onClick={scrollToTop}>
                <FaAngleUp />
              </button>
            </Tooltip>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Shrubs;
